import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { PAY_URL } from "../../../BaseURL";

export const addUserAuthPerson = createAsyncThunk(
    '/add/addUserAuthPerson',
    async (add) => {

        try {
            const myurl = `${PAY_URL}/user/manage-auth-person`;

            const response = await axios({
                method: 'post',
                url: myurl,
                data: add,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });

            const addUserAuthPerson = response.data;
            // console.log(addUserAuthPerson, '@@@')

            if (addUserAuthPerson.success === true) {
                toast.success(addUserAuthPerson?.message);
                return addUserAuthPerson;
            } else {
                // console.log(addUserAuthPerson.message, "&&&&")
                throw new Error(addUserAuthPerson.message);
            }
        } catch (error) {
            console.log(error, "!!!!")
            toast.error(error.response.data.message);
            return error;
        }
    }
);


const addUserAuthPersonSlice = createSlice({
    name: "addUserAuthPerson",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(addUserAuthPerson.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addUserAuthPerson.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(addUserAuthPerson.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default addUserAuthPersonSlice.reducer;